import React from 'react';
import PropTypes from "prop-types";
import LazyMetrics from '@/pages/dashboard-year/LazyMetrics';
import EducatorProjectEvaluationsByMonth from './EducatorProjectEvaluationsByMonth';
import CompositeEducatorProjectEvaluations from './CompositeEducatorProjectEvaluations';
import PartnerProjectEvaluationsByMonth from './PartnerProjectEvaluationsByMonth';
import CompositePartnerProjectEvaluations from './CompositePartnerProjectEvaluations';
import EducatorEventEvaluationsByMonth from './EducatorEventEvaluationsByMonth';
import CompositeEducatorEventEvaluations from './CompositeEducatorEventEvaluations';
import PartnerEventEvaluationsByMonth from './PartnerEventEvaluationsByMonth';
import CompositePartnerEventEvaluations from './CompositePartnerEventEvaluations';
import EvalAllResponses from "./EvalAllResponses";

DashboardOverviewEvaluations.propTypes = {
  params: PropTypes.object.isRequired,
};

export default function DashboardOverviewEvaluations(props) {
  const { params } = props;

  return (
    <>
      <LazyMetrics
        title="Project Evaluations - Educators"
        columns={1}
      >
        <EducatorProjectEvaluationsByMonth {...params} />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          <CompositeEducatorProjectEvaluations {...params} titleOnly={true} />
        </div>
      </LazyMetrics>
      <LazyMetrics
        title="Project Evaluations - Partners"
        columns={1}
      >
        <PartnerProjectEvaluationsByMonth {...params} />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          <CompositePartnerProjectEvaluations {...params} titleOnly={true} />
        </div>
      </LazyMetrics>
      <LazyMetrics
        title="Event Evaluations - Educators"
        columns={1}
      >
        <EducatorEventEvaluationsByMonth {...params} />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          <CompositeEducatorEventEvaluations {...params} titleOnly={true} />
        </div>
      </LazyMetrics>
      <LazyMetrics
        title="Event Evaluations - Partners"
        columns={1}
      >
        <PartnerEventEvaluationsByMonth {...params} />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          <CompositePartnerEventEvaluations {...params} titleOnly={true} />
        </div>
      </LazyMetrics>

      {/*Evaluation Responses*/}
      <EvalAllResponses {...params} />

    </>
  );
}
